import { Component, Input } from "@angular/core";
import { Anagrafica } from "../../../models/anagrafica";

@Component({
  selector: 'app-dati-generali-anagrafiche-search',
  templateUrl: 'dati-generali-anagrafiche-search.component.html'
})

export class DatiGeneraliAnagraficheSearchComponent<T extends Anagrafica> {
  @Input() option: { hasDetailsAnagrafica: boolean, anagrafica: T};
  @Input() isPartiSearch: boolean;
  @Input() isLegale: boolean;
  @Input() hideOtherData: boolean;
  @Input() isControparte: boolean = false;

}
